/* Shopify AJAX Cart */
(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' CAD';
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } }).then(r => r.json());
  }

  function addItem(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(r => r.json());
  }

  function changeItem(variantId, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(r => r.json());
  }

  function updateCartBadge(cart) {
    var total = (cart && cart.item_count) ? cart.item_count : 0;
    document.querySelectorAll('.cart-badge').forEach(function (b) {
      b.textContent = total > 0 ? total : '';
      b.classList.toggle('visible', total > 0);
    });
  }

  function renderCartDrawer(cart) {
    var itemsEl = document.getElementById('cart-items');
    var footerEl = document.getElementById('cart-footer');
    if (!itemsEl) return;

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = 'block';

    itemsEl.innerHTML = cart.items.map(function (item) {
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
        ? 'Size: ' + item.variant_title
        : '';
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '">'
        : '';
      return '<div class="cart-item">' +
        '<div class="cart-item-img">' + imgHtml + '</div>' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + (item.product_title || '') + '</div>' +
          '<div class="cart-item-variant">' + variantLabel + '</div>' +
          '<div class="cart-item-bottom">' +
            '<div class="cart-qty">' +
              '<button class="cart-qty-btn" onclick="window.cartChangeQty(' + item.variant_id + ',' + (item.quantity - 1) + ')">−</button>' +
              '<span class="cart-qty-num">' + item.quantity + '</span>' +
              '<button class="cart-qty-btn" onclick="window.cartChangeQty(' + item.variant_id + ',' + (item.quantity + 1) + ')">+</button>' +
            '</div>' +
            '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px">' +
              '<span class="cart-item-price">' + formatMoney(item.line_price) + '</span>' +
              '<button class="cart-remove-btn" onclick="window.cartRemove(' + item.variant_id + ')">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    var subtotalEl = document.getElementById('cart-subtotal-val');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  window.openCart = function () {
    fetchCart().then(function (cart) {
      renderCartDrawer(cart);
      updateCartBadge(cart);
      var overlay = document.getElementById('cart-overlay');
      var drawer = document.getElementById('cart-drawer');
      if (overlay) overlay.classList.add('open');
      if (drawer) drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  };

  window.closeCart = function () {
    var overlay = document.getElementById('cart-overlay');
    var drawer = document.getElementById('cart-drawer');
    if (overlay) overlay.classList.remove('open');
    if (drawer) drawer.classList.remove('open');
    document.body.style.overflow = '';
  };

  window.cartChangeQty = function (variantId, newQty) {
    if (newQty < 1) { window.cartRemove(variantId); return; }
    changeItem(variantId, newQty).then(function (cart) {
      renderCartDrawer(cart);
      updateCartBadge(cart);
    });
  };

  window.cartRemove = function (variantId) {
    changeItem(variantId, 0).then(function (cart) {
      renderCartDrawer(cart);
      updateCartBadge(cart);
    });
  };

  window.addToShopifyCart = function (variantId, quantity, callback) {
    addItem(variantId, quantity)
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        updateCartBadge(cart);
        if (callback) callback(cart);
        else window.openCart();
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        if (window.showToast) window.showToast('Could not add to cart');
      });
  };

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(updateCartBadge);
  });
})();
